export default __webpack_public_path__ + "static/media/GM.8c91f347.svg";